import { useCallback, useEffect, useState } from "react";

const INIT_SELECTED_FILTERS = {
  product_type: {},
  product_use: {},
  product_plant_type: {},
  product_pest_type: {},
  product_disease_type: {},
  product_brand: {},
};

/**
 * Handle the filters of the archive product page.
 * @params initialFilters - object made of the filter ids in query params
 * @return {object} { selectedFilters, handleSelectFilters }
 */
export const useSelectedFilters = (initialFilters) => {
  const [selectedFilters, setSelectedFilters] = useState(
    initialFilters ?? INIT_SELECTED_FILTERS
  );

  // Add or remove a filter to the list of selected filters
  const handleSelectFilter = useCallback(
    (filterId, filter = null, addToList = true) => {
      const taxonomy = filter.taxonomy;
      let copy = { ...selectedFilters };
      let copyTax = { ...selectedFilters[taxonomy] };

      // Add element to the list
      if (addToList) {
        copyTax[filterId] = filter;
      }
      // Delete element
      else {
        delete copyTax[filterId];
      }
      copy[taxonomy] = copyTax;

      setSelectedFilters({ ...copy });
    },
    [selectedFilters, setSelectedFilters]
  );

  // Listen to the event "onSbmArchiveProductCheckFilter".
  // If action is 1, add the filter to the list
  // If action is 0, delete the filter from the list
  // If action is -1, reset the filter list
  useEffect(() => {
    const callback = (e) => {
      const detail = e.detail;
      switch (detail.action) {
        case 1:
          handleSelectFilter(detail.id, detail.filter);
          break;
        case 0:
          handleSelectFilter(detail.id, detail.filter, false);
          break;
        default:
          setSelectedFilters(INIT_SELECTED_FILTERS);
      }
    };
    document.addEventListener("onSbmArchiveProductCheckFilter", callback);
    return () => {
      document.removeEventListener("onSbmArchiveProductCheckFilter", callback);
    };
  }, [handleSelectFilter]);

  return { selectedFilters, handleSelectFilter };
};
